export const Logistics = {
  shippingOrderTrackingStatus: {
    url: "/logistics/tracking/{shippingOrderId}",
    method: ["GET"]
  }
};
